import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "space-y-4 sm:space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "card-body space-y-4" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "relative flex-1 max-w-md"
}
const _hoisted_6 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_7 = ["onKeydown", "placeholder"]
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "border-t border-gray-200 dark:border-gray-700 pt-4 space-y-4 animate-fadeIn"
}
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["value"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "flex justify-end pt-2" }
const _hoisted_18 = {
  key: 1,
  class: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 pt-2 border-t border-gray-100 dark:border-gray-800"
}
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = { class: "flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "font-medium" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_24 = { class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200 border border-blue-200 dark:border-blue-800" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = {
  key: 0,
  class: "card-body text-center py-12"
}
const _hoisted_27 = { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }
const _hoisted_28 = { class: "text-gray-500 dark:text-gray-400 mb-4" }
const _hoisted_29 = { class: "flex flex-col sm:flex-row gap-2 justify-center" }
const _hoisted_30 = { class: "text-gray-900 dark:text-white" }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "w-full min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_33 = { class: "bg-[#edf6fd]/80 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_37 = { class: "space-y-3" }
const _hoisted_38 = { class: "text-sm font-medium text-gray-600 dark:text-gray-300" }
const _hoisted_39 = { class: "text-sm text-gray-900 dark:text-white min-w-0 max-w-[60%] flex justify-end" }
const _hoisted_40 = {
  key: 0,
  class: "flex justify-end space-x-3 pt-3 border-t border-gray-200 dark:border-gray-600"
}
const _hoisted_41 = {
  key: 1,
  class: "flex flex-col sm:flex-row justify-between sm:justify-end items-center gap-4 mt-4 px-4"
}
const _hoisted_42 = { class: "text-sm text-gray-500 dark:text-gray-400 order-2 sm:order-1" }
const _hoisted_43 = { class: "flex space-x-1 sm:space-x-2 order-1 sm:order-2" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "hidden sm:flex space-x-1 items-center" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  class: "px-2 py-1 text-gray-500 dark:text-gray-400 flex items-center justify-center min-w-[2.5rem] h-9 text-sm font-medium"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 1,
  class: "px-2 py-1 text-gray-500 dark:text-gray-400 flex items-center justify-center min-w-[2.5rem] h-9 text-sm font-medium"
}
const _hoisted_50 = { class: "flex sm:hidden space-x-1 items-center" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "px-1 text-gray-500 dark:text-gray-400 text-sm"
}
const _hoisted_53 = { class: "btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm btn-primary shadow-md" }
const _hoisted_54 = {
  key: 4,
  class: "px-1 text-gray-500 dark:text-gray-400 text-sm"
}
const _hoisted_55 = ["disabled"]

import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useThemeStore } from '@/stores/theme'
import SearchNotFoundIcon from '@/components/icons/SearchNotFoundIcon.vue'
import { Search, X, Filter, RotateCcw, ChevronLeft, ChevronRight } from 'lucide-vue-next'

// Types
interface Column {
  key: string
  label: string
  sortable?: boolean
  formatter?: (value: any, item: any) => string
  align?: 'left' | 'center' | 'right'
  width?: string
}

interface SortableColumn {
  key: string
  label: string
}

interface Sort {
  field: string
  direction: 'asc' | 'desc'
}

// Props
interface Props {
  data: any[]
  columns: Column[]
  itemKey?: string
  loading?: boolean
  showSearch?: boolean
  searchable?: boolean
  searchQuery?: string
  searchDebounce?: number
  showFilters?: boolean
  showPagination?: boolean
  showSummary?: boolean
  showSearchSection?: boolean
  searchPlaceholder?: string
  itemLabel?: string
  itemsPerPage?: number
  itemsPerPageOptions?: number[]
  summaryIcon?: any
  filters?: Record<string, any>
  sortableColumns?: SortableColumn[]
  mobileColumns?: Column[]
  tableId?: string // Unique identifier for localStorage persistence
  breakpoint?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '1670px' | string // Breakpoint to switch between desktop table and mobile card view
  actionsWidth?: string
  serverSide?: boolean
  totalItems?: number
  currentPage?: number
  disableClientFilter?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    data: {},
    columns: {},
    itemKey: { default: 'id' },
    loading: { type: Boolean, default: false },
    showSearch: { type: Boolean, default: true },
    searchable: { type: Boolean, default: undefined },
    searchQuery: { default: '' },
    searchDebounce: { default: 400 },
    showFilters: { type: Boolean, default: true },
    showPagination: { type: Boolean, default: true },
    showSummary: { type: Boolean, default: true },
    showSearchSection: { type: Boolean, default: true },
    searchPlaceholder: { default: 'Search...' },
    itemLabel: { default: 'items' },
    itemsPerPage: { default: 10 },
    itemsPerPageOptions: { default: () => [5, 10, 25, 50] },
    summaryIcon: {},
    filters: { default: () => ({}) },
    sortableColumns: { default: () => [] },
    mobileColumns: { default: () => [] },
    tableId: { default: 'default-table' },
    breakpoint: { default: 'xl' },
    actionsWidth: {},
    serverSide: { type: Boolean, default: undefined },
    totalItems: { default: undefined },
    currentPage: { default: 1 },
    disableClientFilter: { type: Boolean, default: false }
  },
  emits: ["search", "sort", "filter", "pageChange", "page-change", "update:currentPage", "update:current-page", "itemsPerPageChange", "items-per-page-change", "update:itemsPerPage", "update:items-per-page"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const isServerSide = computed(() => {
  if (props.serverSide !== undefined) {
    return props.serverSide
  }
  return props.totalItems !== undefined
})

const effectiveShowSearch = computed(() => {
  return props.searchable !== undefined ? props.searchable : props.showSearch
})

const desktopContainerClass = computed(() => {
  switch (props.breakpoint) {
    case '1670px':
      return 'hidden min-[1710px]:block overflow-hidden desktop-table-container'
    case '2xl':
      return 'hidden 2xl:block overflow-hidden desktop-table-container'
    case 'lg':
      return 'hidden lg:block overflow-hidden desktop-table-container'
    case 'md':
      return 'hidden md:block overflow-hidden desktop-table-container'
    case 'sm':
      return 'hidden sm:block overflow-hidden desktop-table-container'
    case 'xl':
    default:
      return 'hidden xl:block overflow-hidden desktop-table-container'
  }
})

const mobileContainerClass = computed(() => {
  switch (props.breakpoint) {
    case '1670px':
      return 'min-[1710px]:hidden space-y-4 mobile-card-container'
    case '2xl':
      return '2xl:hidden space-y-4 mobile-card-container'
    case 'lg':
      return 'lg:hidden space-y-4 mobile-card-container'
    case 'md':
      return 'md:hidden space-y-4 mobile-card-container'
    case 'sm':
      return 'sm:hidden space-y-4 mobile-card-container'
    case 'xl':
    default:
      return 'xl:hidden space-y-4 mobile-card-container'
  }
})

// Emits
const emit = __emit

// Theme store
const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)

// Local state
const searchQuery = ref(props.searchQuery || '')
let searchDebounceTimer: ReturnType<typeof setTimeout> | null = null
const showAdvancedFilters = ref(false)
const sortField = ref('')
const sortOrder = ref<'asc' | 'desc'>('asc')
const itemsPerPageLocal = ref(props.itemsPerPage)
const currentPage = ref(props.currentPage || 1)
const filters = ref({ ...props.filters })

// Watch for external currentPage changes
watch(
  () => props.currentPage,
  newPage => {
    if (newPage !== undefined && newPage !== currentPage.value) {
      currentPage.value = newPage
    }
  }
)

// Computed properties
const currentSort = ref<Sort>({ field: '', direction: 'asc' })

const hasActiveFilters = computed(() => {
  return !!(
    searchQuery.value ||
    sortField.value ||
    Object.values(filters.value).some(v => v !== '' && v !== null && v !== undefined && v !== 'all')
  )
})

const filteredData = computed(() => {
  if (isServerSide.value || props.disableClientFilter) {
    return props.data
  }

  let result = [...props.data]

  // Apply search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase().trim()
    const valueToSearchString = (val: any): string => {
      if (val === null || val === undefined) return ''
      if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean')
        return String(val)
      if (Array.isArray(val)) return val.map(v => valueToSearchString(v)).join(' ')
      if (typeof val === 'object') {
        const parts: string[] = []
        // Shallow collect common string fields (name, title, label) and primitive values
        Object.entries(val).forEach(([, v]) => {
          if (v === null || v === undefined) return
          if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
            parts.push(String(v))
            return
          }
          // If nested object has a common identifier, prefer that
          if (typeof v === 'object' && v !== null) {
            if ((v as any).name) parts.push(String((v as any).name))
            else if ((v as any).title) parts.push(String((v as any).title))
            else if ((v as any).label) parts.push(String((v as any).label))
          }
        })
        return parts.join(' ')
      }
      return String(val)
    }

    result = result.filter(item => {
      // 1. Check configured columns
      const matchesColumn = props.columns.some(column => {
        const value = getNestedValue(item, column.key)
        return valueToSearchString(value).toLowerCase().includes(query)
      })
      if (matchesColumn) return true

      // 2. Also check top-level item attributes (e.g. description, file_name, notes, email, phone)
      if (item && typeof item === 'object') {
        const matchesAnyField = Object.entries(item).some(([, val]) => {
          if (val === null || val === undefined) return false
          if (typeof val === 'string' || typeof val === 'number') {
            return String(val).toLowerCase().includes(query)
          }
          return false
        })
        if (matchesAnyField) return true

        // 3. Check combined name fields if present
        if (item.first_name || item.last_name) {
          const fullName = `${item.first_name || ''} ${item.middle_name || ''} ${item.last_name || ''}`.replace(/\s+/g, ' ').trim().toLowerCase()
          if (fullName.includes(query)) return true
        }
      }

      return false
    })
  }

  // Apply custom filters
  Object.entries(filters.value).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined && value !== 'all') {
      result = result.filter(item => {
        const itemValue = getNestedValue(item, key)
        return itemValue === value
      })
    }
  })

  return result
})

const sortedData = computed(() => {
  if (!currentSort.value.field) return filteredData.value

  return [...filteredData.value].sort((a, b) => {
    const aValue = getNestedValue(a, currentSort.value.field)
    const bValue = getNestedValue(b, currentSort.value.field)

    let comparison = 0
    if (aValue < bValue) comparison = -1
    if (aValue > bValue) comparison = 1

    return currentSort.value.direction === 'desc' ? -comparison : comparison
  })
})

const totalItems = computed(() => {
  if (isServerSide.value && props.totalItems !== undefined) {
    return props.totalItems
  }
  return sortedData.value.length
})

const totalPages = computed(() => {
  const count = totalItems.value
  const perPage = itemsPerPageLocal.value || props.itemsPerPage || 10
  return Math.ceil(count / perPage)
})

const displayedData = computed(() => {
  // If server-side, the backend already paginated the data. Do NOT slice.
  if (isServerSide.value) {
    return sortedData.value
  }

  if (!props.showPagination) return sortedData.value

  const start = (currentPage.value - 1) * itemsPerPageLocal.value
  const end = start + itemsPerPageLocal.value
  return sortedData.value.slice(start, end)
})

const mobileColumnsComputed = computed(() => {
  return props.mobileColumns.length > 0 ? props.mobileColumns : props.columns.slice(0, 3)
})

// Methods
const getItemKey = (item: any, index: number): string | number => {
  return getNestedValue(item, props.itemKey) || index
}

const getNestedValue = (obj: any, path: string): any => {
  return path.split('.').reduce((o, p) => o?.[p], obj)
}

const formatCellValue = (item: any, column: Column): string => {
  const value = getNestedValue(item, column.key)

  if (column.formatter) {
    return column.formatter(value, item)
  }

  return String(value || '')
}

const handleSearch = () => {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
  }
  searchDebounceTimer = setTimeout(() => {
    searchDebounceTimer = null
    currentPage.value = 1
    emit('search', searchQuery.value)
  }, props.searchDebounce)
}

const handleImmediateSearch = () => {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
  currentPage.value = 1
  emit('search', searchQuery.value)
}

const clearSearch = () => {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
  searchQuery.value = ''
  currentPage.value = 1
  emit('search', '')
}

const toggleAdvancedFilters = () => {
  showAdvancedFilters.value = !showAdvancedFilters.value
}

const updateFilter = (key: string, value: any) => {
  filters.value[key] = value
  currentPage.value = 1
  emit('filter', { ...filters.value })
}

const sortBy = (field: string) => {
  if (currentSort.value.field === field) {
    currentSort.value.direction = currentSort.value.direction === 'asc' ? 'desc' : 'asc'
  } else {
    currentSort.value.field = field
    currentSort.value.direction = 'asc'
  }

  // Update form controls to match
  sortField.value = field
  sortOrder.value = currentSort.value.direction

  emit('sort', { ...currentSort.value })
}

const handleSortChange = () => {
  if (sortField.value) {
    currentSort.value.field = sortField.value
    currentSort.value.direction = sortOrder.value
  } else {
    // Reset sorting when "Default" is selected
    currentSort.value = { field: '', direction: 'asc' }
  }
  emit('sort', { ...currentSort.value })
}

const handleItemsPerPageChange = () => {
  currentPage.value = 1
  emit('itemsPerPageChange', itemsPerPageLocal.value)
  emit('items-per-page-change', itemsPerPageLocal.value)
  emit('update:itemsPerPage', itemsPerPageLocal.value)
  emit('update:items-per-page', itemsPerPageLocal.value)
}

const goToPage = (page: number) => {
  if (page >= 1 && (totalPages.value === 0 || page <= totalPages.value)) {
    currentPage.value = page
    emit('pageChange', page)
    emit('page-change', page)
    emit('update:currentPage', page)
    emit('update:current-page', page)
  }
}

const clearAllFilters = () => {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
  searchQuery.value = ''
  sortField.value = ''
  sortOrder.value = 'asc'
  currentSort.value = { field: '', direction: 'asc' }
  itemsPerPageLocal.value = props.itemsPerPage
  // Reset all filters to empty strings
  Object.keys(filters.value).forEach(key => {
    filters.value[key] = ''
  })
  currentPage.value = 1

  emit('search', '')
  emit('sort', { field: '', direction: 'asc' })
  emit('filter', { ...filters.value })
  emit('itemsPerPageChange', props.itemsPerPage)
  emit('items-per-page-change', props.itemsPerPage)
  emit('update:itemsPerPage', props.itemsPerPage)
  emit('update:items-per-page', props.itemsPerPage)
  emit('pageChange', 1)
  emit('page-change', 1)
  emit('update:currentPage', 1)
  emit('update:current-page', 1)
}

const getSmartVisiblePages = () => {
  const pages: number[] = []

  if (currentPage.value <= 4) {
    for (let i = 2; i <= Math.min(5, totalPages.value - 1); i++) {
      pages.push(i)
    }
  } else if (currentPage.value >= totalPages.value - 3) {
    for (let i = Math.max(totalPages.value - 4, 2); i <= totalPages.value - 1; i++) {
      pages.push(i)
    }
  } else {
    for (let i = currentPage.value - 1; i <= currentPage.value + 1; i++) {
      if (i > 1 && i < totalPages.value) {
        pages.push(i)
      }
    }
  }

  return pages
}

// Watch for external data changes to reset pagination
// Only reset to page 1 in client-side mode when items are added/removed,
// never in server-side mode where pagination is driven by server state.
watch(
  () => props.data.length,
  () => {
    if (!isServerSide.value) {
      currentPage.value = 1
    }
  }
)

// Watch for external search query changes
watch(
  () => props.searchQuery,
  newVal => {
    if (newVal !== undefined && newVal !== searchQuery.value) {
      if (searchDebounceTimer) {
        clearTimeout(searchDebounceTimer)
        searchDebounceTimer = null
      }
      searchQuery.value = newVal
    }
  }
)

// Watch for external filter changes
watch(
  () => props.filters,
  newFilters => {
    filters.value = { ...newFilters }
  },
  { deep: true }
)

// Component initialization
onMounted(() => {
  if (props.showPagination) {
    itemsPerPageLocal.value = props.itemsPerPage
  }
})

// Cleanup pending debounce timer on unmount
onBeforeUnmount(() => {
  if (searchDebounceTimer) {
    clearTimeout(searchDebounceTimer)
    searchDebounceTimer = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_vue_loaders = _resolveComponent("vue-loaders")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSearchSection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (effectiveShowSearch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(Search), { class: "h-5 w-5 text-gray-400" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      onInput: handleSearch,
                      onKeydown: _withKeys(_withModifiers(handleImmediateSearch, ["prevent"]), ["enter"]),
                      placeholder: _ctx.searchPlaceholder,
                      class: "block w-full pl-10 pr-10 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-[#0275b1]/40 focus:border-[#0275b1] dark:focus:ring-sky-500/40 dark:focus:border-sky-500 transition duration-200 shadow-xs hover:shadow-sm"
                    }, null, 40, _hoisted_7), [
                      [_vModelText, searchQuery.value]
                    ]),
                    (searchQuery.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: clearSearch,
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-200",
                          title: "Clear search"
                        }, [
                          _createVNode(_unref(X), { class: "h-4 w-4" })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.showFilters)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: toggleAdvancedFilters,
                      class: _normalizeClass(["btn btn-outline btn-sm flex items-center gap-2", { 'btn-primary': showAdvancedFilters.value }])
                    }, [
                      _createVNode(_unref(Filter), { class: "h-4 w-4" }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "hidden sm:inline" }, "Filters", -1))
                    ], 2))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "actions")
              ])
            ]),
            (showAdvancedFilters.value && _ctx.showFilters)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "filters", {
                      filters: filters.value,
                      updateFilter: updateFilter
                    }),
                    (_ctx.showPagination)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Items per page ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((itemsPerPageLocal).value = $event)),
                            onChange: handleItemsPerPageChange,
                            class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPageOptions, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option,
                                value: option
                              }, _toDisplayString(option), 9, _hoisted_12))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, itemsPerPageLocal.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sortableColumns.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Sort by ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortField).value = $event)),
                            onChange: handleSortChange,
                            class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                          }, [
                            _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Default", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortableColumns, (column) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: column.key,
                                value: column.key
                              }, _toDisplayString(column.label), 9, _hoisted_14))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, sortField.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sortableColumns.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Order ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortOrder).value = $event)),
                            onChange: handleSortChange,
                            disabled: !sortField.value,
                            class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:shadow-none"
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("option", { value: "asc" }, "Ascending", -1),
                            _createElementVNode("option", { value: "desc" }, "Descending", -1)
                          ]))], 40, _hoisted_16), [
                            [_vModelSelect, sortOrder.value]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: clearAllFilters,
                      class: "btn btn-outline btn-sm flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200"
                    }, [
                      _createVNode(_unref(RotateCcw), { class: "h-4 w-4" }),
                      _cache[18] || (_cache[18] = _createTextVNode(" Clear All Filters ", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showSummary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.summaryIcon)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.summaryIcon), {
                            key: 0,
                            class: "h-4 w-4"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(displayedData.value.length), 1),
                      _cache[19] || (_cache[19] = _createTextVNode(" of ", -1)),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(totalItems.value), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.itemLabel), 1)
                    ]),
                    (hasActiveFilters.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, [
                            _createVNode(_unref(Filter), { class: "h-3 w-3 mr-1" }),
                            _cache[20] || (_cache[20] = _createTextVNode(" Filtered ", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _renderSlot(_ctx.$slots, "summary", {
                    totalItems: totalItems.value,
                    displayedItems: displayedData.value.length
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      (displayedData.value.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _renderSlot(_ctx.$slots, "empty-state", {}, () => [
              _createVNode(SearchNotFoundIcon),
              _createElementVNode("h3", _hoisted_27, " No " + _toDisplayString(_ctx.itemLabel) + " found ", 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(hasActiveFilters.value
                ? "Try adjusting your search or filters to find what you're looking for."
                : `Get started by adding your first ${_ctx.itemLabel.slice(0, -1)}.`), 1),
              _createElementVNode("div", _hoisted_29, [
                (hasActiveFilters.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: clearAllFilters,
                      class: "btn btn-outline btn-sm"
                    }, " Clear Filters "))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "empty-actions")
              ])
            ])
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([_ctx.$slots.loading ? 'w-full overflow-hidden' : 'card-body flex flex-col justify-center items-center py-12'])
            }, [
              _renderSlot(_ctx.$slots, "loading", {}, () => [
                _createVNode(_component_vue_loaders, {
                  name: "line-scale",
                  color: isDarkMode.value ? '#34d399' : '#0b6623',
                  scale: "1.2",
                  class: "mb-4"
                }, null, 8, ["color"]),
                _createElementVNode("span", _hoisted_30, "Loading " + _toDisplayString(_ctx.itemLabel) + "...", 1)
              ])
            ], 2))
          : (displayedData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", {
                  class: _normalizeClass([desktopContainerClass.value, props.breakpoint === '1670px' ? 'datatable-breakpoint-1670 desktop-table-container' : ''])
                }, [
                  _createElementVNode("table", _hoisted_32, [
                    _createElementVNode("thead", _hoisted_33, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: column.key,
                            class: _normalizeClass([
                    'px-6 py-3.5 text-left text-xs font-bold text-[#0b6623] dark:text-emerald-300 uppercase tracking-wider',
                    column.sortable
                      ? 'cursor-pointer hover:bg-[#edf6fd] dark:hover:bg-gray-700'
                      : '',
                    column.align === 'center'
                      ? 'text-center'
                      : column.align === 'right'
                      ? 'text-right'
                      : 'text-left'
                  ]),
                            style: _normalizeStyle(column.width ? { width: column.width } : undefined),
                            onClick: ($event: any) => (column.sortable ? sortBy(column.key) : null)
                          }, [
                            _createTextVNode(_toDisplayString(column.label) + " ", 1),
                            (column.sortable && currentSort.value.field === column.key)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(currentSort.value.direction === 'asc' ? '▲' : '▼'), 1))
                              : _createCommentVNode("", true)
                          ], 14, _hoisted_34))
                        }), 128)),
                        (_ctx.$slots.actions || _ctx.$slots['row-actions'])
                          ? (_openBlock(), _createElementBlock("th", {
                              key: 0,
                              class: "px-6 py-3.5 text-center text-xs font-bold text-[#0b6623] dark:text-emerald-300 uppercase tracking-wider",
                              style: _normalizeStyle(_ctx.actionsWidth ? { width: _ctx.actionsWidth } : undefined)
                            }, " Actions ", 4))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedData.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: getItemKey(item, index),
                          class: "hover:bg-gray-50 dark:hover:bg-gray-800 transition"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: column.key,
                              class: _normalizeClass([
                    'px-6 py-4',
                    column.align === 'center'
                      ? 'text-center'
                      : column.align === 'right'
                      ? 'text-right'
                      : 'text-left'
                  ]),
                              style: _normalizeStyle(column.width ? { width: column.width } : undefined)
                            }, [
                              _renderSlot(_ctx.$slots, `cell-${column.key}`, {
                                item: item,
                                value: getNestedValue(item, column.key)
                              }, () => [
                                _createTextVNode(_toDisplayString(formatCellValue(item, column)), 1)
                              ])
                            ], 6))
                          }), 128)),
                          (_ctx.$slots.actions || _ctx.$slots['row-actions'])
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                class: "px-6 py-4 whitespace-nowrap text-center",
                                style: _normalizeStyle(_ctx.actionsWidth ? { width: _ctx.actionsWidth } : undefined)
                              }, [
                                _renderSlot(_ctx.$slots, "row-actions", {
                                  item: item,
                                  index: index
                                }, () => [
                                  _renderSlot(_ctx.$slots, "actions", {
                                    item: item,
                                    index: index
                                  })
                                ])
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([mobileContainerClass.value, props.breakpoint === '1670px' ? 'datatable-breakpoint-1670 mobile-card-container' : ''])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedData.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: getItemKey(item, index),
                      class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
                    }, [
                      _renderSlot(_ctx.$slots, "mobile-card", {
                        item: item,
                        index: index
                      }, () => [
                        _createElementVNode("div", _hoisted_37, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileColumnsComputed.value, (column) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: column.key,
                              class: "flex items-center justify-between"
                            }, [
                              _createElementVNode("span", _hoisted_38, _toDisplayString(column.label) + ": ", 1),
                              _createElementVNode("span", _hoisted_39, [
                                _renderSlot(_ctx.$slots, `mobile-${column.key}`, {
                                  item: item,
                                  value: getNestedValue(item, column.key)
                                }, () => [
                                  _createTextVNode(_toDisplayString(formatCellValue(item, column)), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (_ctx.$slots.actions || _ctx.$slots['row-actions'] || _ctx.$slots['mobile-actions'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _renderSlot(_ctx.$slots, "mobile-actions", {
                                  item: item,
                                  index: index
                                }, () => [
                                  _renderSlot(_ctx.$slots, "row-actions", {
                                    item: item,
                                    index: index
                                  }, () => [
                                    _renderSlot(_ctx.$slots, "actions", {
                                      item: item,
                                      index: index
                                    })
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true)
    ]),
    (_ctx.showPagination && totalPages.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, " Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value) + " (" + _toDisplayString(totalItems.value) + " total) ", 1),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              class: "btn btn-sm px-2 sm:px-3",
              disabled: currentPage.value === 1,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(currentPage.value - 1))),
              "aria-label": "Previous page"
            }, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "hidden sm:inline" }, "Previous", -1)),
              _createVNode(_unref(ChevronLeft), { class: "h-4 w-4 sm:hidden" })
            ], 8, _hoisted_44),
            _createElementVNode("div", _hoisted_45, [
              (totalPages.value <= 7)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(totalPages.value, (page) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: page,
                      onClick: ($event: any) => (goToPage(page)),
                      class: _normalizeClass(["btn btn-sm px-3 min-w-[2.5rem] h-9 flex items-center justify-center transition-colors duration-200", {
                'btn-primary shadow-md': page === currentPage.value,
                'btn-outline hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500':
                  page !== currentPage.value
              }])
                    }, _toDisplayString(page), 11, _hoisted_46))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage(1))),
                      class: _normalizeClass(["btn btn-sm px-3 min-w-[2.5rem] h-9 flex items-center justify-center transition-colors duration-200", {
                'btn-primary shadow-md': 1 === currentPage.value,
                'btn-outline hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500':
                  1 !== currentPage.value
              }])
                    }, " 1 ", 2),
                    (currentPage.value > 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, " ⋯ "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSmartVisiblePages(), (page) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: page,
                        onClick: ($event: any) => (goToPage(page)),
                        class: _normalizeClass(["btn btn-sm px-3 min-w-[2.5rem] h-9 flex items-center justify-center transition-colors duration-200", {
                  'btn-primary shadow-md': page === currentPage.value,
                  'btn-outline hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500':
                    page !== currentPage.value
                }])
                      }, _toDisplayString(page), 11, _hoisted_48))
                    }), 128)),
                    (currentPage.value < totalPages.value - 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, " ⋯ "))
                      : _createCommentVNode("", true),
                    (totalPages.value > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage(totalPages.value))),
                          class: _normalizeClass(["btn btn-sm px-3 min-w-[2.5rem] h-9 flex items-center justify-center transition-colors duration-200", {
                'btn-primary shadow-md': totalPages.value === currentPage.value,
                'btn-outline hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500':
                  totalPages.value !== currentPage.value
              }])
                        }, _toDisplayString(totalPages.value), 3))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_50, [
              (totalPages.value <= 5)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(totalPages.value, (page) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: page,
                      onClick: ($event: any) => (goToPage(page)),
                      class: _normalizeClass(["btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm transition-colors duration-200", {
                'btn-primary shadow-md': page === currentPage.value,
                'btn-outline hover:bg-gray-50 dark:hover:bg-gray-700': page !== currentPage.value
              }])
                    }, _toDisplayString(page), 11, _hoisted_51))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (currentPage.value > 2)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (goToPage(1))),
                          class: "btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm transition-colors duration-200 btn-outline hover:bg-gray-50 dark:hover:bg-gray-700"
                        }, " 1 "))
                      : _createCommentVNode("", true),
                    (currentPage.value > 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, "⋯"))
                      : _createCommentVNode("", true),
                    (currentPage.value > 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (goToPage(currentPage.value - 1))),
                          class: "btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm transition-colors duration-200 btn-outline hover:bg-gray-50 dark:hover:bg-gray-700"
                        }, _toDisplayString(currentPage.value - 1), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", _hoisted_53, _toDisplayString(currentPage.value), 1),
                    (currentPage.value < totalPages.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (goToPage(currentPage.value + 1))),
                          class: "btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm transition-colors duration-200 btn-outline hover:bg-gray-50 dark:hover:bg-gray-700"
                        }, _toDisplayString(currentPage.value + 1), 1))
                      : _createCommentVNode("", true),
                    (currentPage.value < totalPages.value - 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, "⋯"))
                      : _createCommentVNode("", true),
                    (currentPage.value < totalPages.value - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (goToPage(totalPages.value))),
                          class: "btn btn-sm px-2 min-w-[2rem] h-8 flex items-center justify-center text-sm transition-colors duration-200 btn-outline hover:bg-gray-50 dark:hover:bg-gray-700"
                        }, _toDisplayString(totalPages.value), 1))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _createElementVNode("button", {
              class: "btn btn-sm px-2 sm:px-3",
              disabled: currentPage.value === totalPages.value,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (goToPage(currentPage.value + 1))),
              "aria-label": "Next page"
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "hidden sm:inline" }, "Next", -1)),
              _createVNode(_unref(ChevronRight), { class: "h-4 w-4 sm:hidden" })
            ], 8, _hoisted_55)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})